export const Svg_102 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={70}
    height={70}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M29.167 52.5h2.916V40.833c1.216 0 2.249-.425 3.1-1.276.85-.85 1.276-1.883 1.276-3.099v-8.75h-2.917v8.75h-1.459v-8.75h-2.916v8.75h-1.459v-8.75h-2.916v8.75c0 1.216.425 2.249 1.276 3.1.85.85 1.884 1.275 3.099 1.275V52.5Zm11.666 0h2.917V27.708c-1.604 0-2.977.572-4.12 1.714-1.142 1.142-1.713 2.515-1.713 4.12v8.75h2.916V52.5Zm-29.166 8.75v-35L35 8.75l23.334 17.5v35H11.666Zm4.375-4.375h37.916v-28.73L35 14.366l-18.958 13.78v28.73Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={22.459}
        x2={48.595}
        y1={16.625}
        y2={54.225}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)